import script from "./external-note-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./external-note-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__